import { useCallback, useEffect, useMemo, useState } from "react"

import { useNetworksDispatchContext } from "@l2r-front/l2r-networks"

import { CampaignDispatchContext, CampaignStateContext, initialState } from "./CampaignContext.context"

interface CampaignContextProviderProps {
    children: React.ReactNode
}

export function CampaignContextProvider(props: CampaignContextProviderProps) {
    const { children } = props
    const [campaignState, setCampaignState] = useState(initialState)
    const { setSelectedLinearLocations } = useNetworksDispatchContext()

    const setHoveredCampaign = useCallback((campaign) => {
        setCampaignState(prevState => ({
            ...prevState,
            hoveredCampaign: campaign,
        }))
    }, [])

    const setCampaignFilters = useCallback((filters) => {
        setCampaignState(prevState => ({
            ...prevState,
            campaignFilters: filters,
        }))
    }, [])

    const setIsExportRunning = useCallback((isRunning) => {
        const campaign = Object.keys(isRunning)[0]
        const isRunningValue = isRunning[campaign];
        setCampaignState(prevState => ({
            ...prevState,
            isExportRunning: {
                ...prevState.isExportRunning,
                [campaign]: isRunningValue
            },
        }))
    }, [])

    const stateValue = useMemo(() => {
        return campaignState
    }, [campaignState])

    const dispatchValue = useMemo(() => {
        return {
            setCampaignState,
            setHoveredCampaign,
            setCampaignFilters,
            setIsExportRunning,
        }
    }, [setCampaignState, setHoveredCampaign, setCampaignFilters, setIsExportRunning])

    useEffect(() => {
        setSelectedLinearLocations(null)
    }, [setSelectedLinearLocations])

    return (
        <CampaignStateContext.Provider value={stateValue}>
            <CampaignDispatchContext.Provider value={dispatchValue}>
                {children}
            </CampaignDispatchContext.Provider>
        </CampaignStateContext.Provider>
    )
}
